import client from '../config/axios';

async function downloadImageService(uri) {
  const response = await client.get(uri, { //TODO: proxy image so this is usable lol
    responseType: "blob",
  })

  const image = new File([response.data], "name");

  return image;
}

export default downloadImageService;